import apiService from '@sonifi/wb-core/services/api.service';
import {
  setConfig,
  setStatus,
} from '@sonifi/wb-remote-ordering/store/selfServiceSlice';
import { setFormErrors } from '@sonifi/wb-widget/store/formErrors/formErrorsSlice';
import { FORM_ERRORS_IDS } from '@sonifi/wb-widget/store/formErrors/formErrorsConstants';
import { getIdFromUrl, parseQueryParams } from '@sonifi/wb-core/utils/parseHelper';
import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';
import { translateFormErrors } from '@sonifi/wb-widget/components/FormErrorMessage/translateFormErrors';
import { ENDPOINTS } from '@sonifi/wb-core/services/endpointsConstants';
import { getGroups } from '@sonifi/wb-group/services/group.service';
import { ORDER_REMOTES_PARAMS } from '@sonifi/wb-group/constants/wbGroupConstants';
import { GROUPS_KEYS } from '@sonifi/wb-group/store/groupsConstants';
import {
  buildAddressAndRemoteBodies,
  buildFormValues,
  buildShippingAddressBody,
} from './remoteOrderingHelper';

export const getRemoteOrders = async (params) => {
  try {
    const query = parseQueryParams(params);
    const url = `${ENDPOINTS.REMOTE_CONTROL_ORDERS}?${query}`;
    const res = await apiService.get(url);
    const orders = res.data.objects;

    return orders;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getAddresses = async (id) => {
  try {
    const url = `${ENDPOINTS.ADDRESSES}/${id}`;
    const res = await apiService.get(url);

    return res?.data;
  } catch (error) {
    return Promise.reject;
  }
};

export const buildForm = (group) => async (dispatch, getState) => {
  const {
    user: { user },
  } = getState();

  const orders = await getRemoteOrders({
    group_id: group.id,
    _order_by: '-created',
  });

  const lastOrder = orders[0];
  let addressee = {};
  if (lastOrder) {
    const addressId = getIdFromUrl({ url: lastOrder.shipping_address, parseToInt: false });
    addressee = await getAddresses(addressId);
  }

  const formValues = buildFormValues({ addressee, user, group, lastOrder });

  dispatch(setConfig(formValues));
};

export const initForm = () => async (dispatch) => {
  try {
    const groups = await dispatch(
      getGroups({
        params: ORDER_REMOTES_PARAMS,
        groupKey: GROUPS_KEYS.orderRemotesGroups,
      }),
    );
    const group = groups[0]; // Default first
    dispatch(buildForm(group));
  } catch (error) {
    console.error(error);
  }
};

export const changeGroup = (id) => async (dispatch, getState) => {
  try {
    const {
      groups: { groups },
    } = getState();

    const group = groups[GROUPS_KEYS.orderRemotesGroups].filter(
      (g) => g.id === parseInt(id),
    )[0];
    dispatch(buildForm(group));
  } catch (error) {
    console.error(error);
  }
};

export const submitForm = (form) => async (dispatch) => {
  dispatch(setStatus(LOADING_STATUS.loading));
  let orderNum = null;
  let formErrors = [];
  const addressUrl = ENDPOINTS.ADDRESSES;

  const { addressBody, remoteBody } = buildAddressAndRemoteBodies(form);

  if (!addressBody.group) {
    dispatch(setStatus(LOADING_STATUS.error));
    dispatch(
      setFormErrors({
        id: FORM_ERRORS_IDS.remoteOrder,
        errors: [
          {
            field: 'Property',
            code: 1,
            error: 'Please select a property before submitting this order.',
          },
        ],
      }),
    );

    return {
      status: LOADING_STATUS.error,
      orderNum,
    };
  }

  await apiService
    .post(addressUrl, addressBody)
    .then(async (res) => {
      const addressee = res?.data;
      const shippingAddress = buildShippingAddressBody({ addressee, form });

      remoteBody.shipping_address = shippingAddress.uri;

      await dispatch(
        setConfig({
          order: { shipping_address: shippingAddress },
        }),
      );
    })
    .catch((err) => {
      formErrors = formErrors.concat(err);
    })
    .finally(async () => {
      await apiService
        .post(ENDPOINTS.REMOTE_CONTROL_ORDERS, remoteBody)
        .then(async (res) => {
          const date = new Date(res.data.created);
          orderNum = date.toISOString().match(/^[\d-]+/)[0] + ':' + res.data.id;
          await dispatch(
            setConfig({ orderNum }),
            dispatch(setStatus(LOADING_STATUS.success)),
          );
        })
        .catch((err) => {
          formErrors = formErrors.concat(err);
        });
    });

  const hasErrors = formErrors.length;
  if (hasErrors) {
    dispatch(setStatus(LOADING_STATUS.error));
    dispatch(
      setFormErrors({
        id: FORM_ERRORS_IDS.remoteOrder,
        errors: translateFormErrors(formErrors),
      }),
    );
  }

  return {
    status: hasErrors ? LOADING_STATUS.error : LOADING_STATUS.success,
    orderNum,
  };
};
